module.exports = __webpack_public_path__ + "img/blank-comic-book_B098RS65BT.201a66de.jpg";